/**
 * Created by rossd on 5/18/2018.
 */
export const LOGIN_REQUEST_BEGIN = "LOGIN_BEGIN"
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_REQUEST_FAIL = 'LOGIN_REQUEST_FAIL';

export const REGISTER_REQUEST_BEGIN = "REGISTER_BEGIN"
export const REGISTER_REQUEST_SUCCESS = 'REGISTER_REQUEST_SUCCESS';
export const REGISTER_REQUEST_FAIL = 'REGISTER_REQUEST_FAIL';

export const SET_SELECTED_ORG = 'SET_SELECTED_ORG';


// WEBPACK FOOTER //
// ./src/actions/types.js